// IMPORTANT TO NOTE:
// Actions/states associated with "navigation" are only for recording purpose.
// ReactNavigation does not actually support using Redux as its state storage.
// We only use these Redux action/states to keep track of navigation status for
// analytics purpose.

import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {navigation as navigationState} from './root.selector';

export const currentScreen = createSelector(
  navigationState,
  get('currentScreen'),
);

export const currentScreenParams = createSelector(
  navigationState,
  get('currentScreenParams'),
);
